import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './dropdown-years.module.scss';
import { Empty } from 'antd';
import { arrow_down_filter_3 } from '../../../../assets/img';

const DropdownYears = (props) => {
  const { options = [], onChange, value, placeholder } = props;
  const [open, setOpen] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className={styles.dropdown}>
      <button onClick={() => setOpen(!open)} className={styles.toggle}>
        {value ? (
          <span className={styles.toggle_label}>{options?.find((opt) => opt.value === value)?.label || value}</span>
        ) : (
          <span>{placeholder}</span>
        )}
        <span className={styles.chevron}>
          <img src={arrow_down_filter_3} />
        </span>
      </button>

      {open && (
        <div className={styles.menu}>
          {options.length ? (
            options.map(({ label, value }) => (
              <div
                key={value}
                onClick={() => {
                  onChange(value);
                  setOpen(false);
                }}
                className={styles.option}
              >
                {label}
              </div>
            ))
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </div>
      )}
    </div>
  );
};

export default DropdownYears;

DropdownYears.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
};
